const SID_KEY = "ea_session_id";
const ANSWERS_KEY = "ea_answers";
const STEP_KEY = "ea_last_step";

function uuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getSessionId() {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid) {
        sid = uuid();
        localStorage.setItem(SID_KEY, sid);
    }
    return sid;
}

export function getRefFromUrl() {
    const url = new URL(window.location.href);
    return url.searchParams.get("ref");
}

export function saveAnswers(answers) {
    localStorage.setItem(ANSWERS_KEY, JSON.stringify(answers));
}

export function loadAnswers() {
    const raw = localStorage.getItem(ANSWERS_KEY);
    return raw ? JSON.parse(raw) : {};
}

export function saveLastStep(step) {
    localStorage.setItem(STEP_KEY, step);
}

export function loadLastStep() {
    return localStorage.getItem(STEP_KEY);
}
